import React from "react";
import {Transportation} from "@Pages/stationToStation/features/companyCard/components/Transportation";
import Row from "@Containers/components/Row";
import Column from "@Containers/components/Column";
import {useTransportTypeById} from "@Translation/hooks/useTransportTypeById";
import {useTranslation} from "@Translation/hooks/useTranslation";
import useIsMobile from "@Hooks/selector/useIsMobile";

export const BestPriceTab = ({tab, routes, active, onClick}: {tab: number, routes: number, active: boolean, onClick: () => void}) => {
    const transportTypeName = useTranslation(useTransportTypeById(tab));
    const isMobile = useIsMobile();

    return (
        <Row
            className={`nav-link ${active ? 'nav-link__active' : ''}`}
            center
            onClick={onClick}
        >
            <Transportation
                width={isMobile ? 24 : 35}
                height={isMobile ? 24 : 35}
                transportType={tab}
            />
            <Column className={'nav-link-content'}>
                    <span>
                        {transportTypeName}
                    </span>
                    <span>
                        x
                        {routes}
                    </span>
            </Column>
        </Row>
    )
}